import { render, staticRenderFns } from "./note_publish.vue?vue&type=template&id=7ca52ba8&scoped=true&"
import script from "./note_publish.vue?vue&type=script&lang=js&"
export * from "./note_publish.vue?vue&type=script&lang=js&"
import style0 from "./note_publish.vue?vue&type=style&index=0&id=7ca52ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca52ba8",
  null
  
)

export default component.exports